export const generatedEconomicsFrontierReport = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-seeded-economics-frontier",
  "artifactId": "artifact-economics-uncertainty-v1",
  "claimState": "model-derived-unvalidated",
  "promotionAllowed": false,
  "operatingRule": "Economics outputs are reproducible planning heuristics. They cannot become price, ROI, or investment claims until dated cost-source and market-source records are attached.",
  "seed": "economics-frontier-v1-2026-06-19",
  "iterations": 512,
  "inputDistributions": {
    "mode": "seeded-planning-heuristic-not-price-forecast",
    "base": {
      "horizonYears": 18,
      "capitalUsdBn": 280,
      "launchMassT": 160,
      "planningLaunchCostUsdPerKg": 1500
    },
    "ranges": {
      "horizonYears": [
        10,
        26
      ],
      "capitalUsdBn": [
        60,
        420
      ],
      "launchMassT": [
        70,
        340
      ],
      "planningLaunchCostUsdPerKg": [
        750,
        3600
      ]
    },
    "units": {
      "horizonYears": "years",
      "capitalUsdBn": "USD billions",
      "launchMassT": "metric tonnes",
      "planningLaunchCostUsdPerKg": "USD/kg"
    },
    "caveat": "Ranges are internal planning bands until dated launch-cost, capex, opex, and market-source records are attached."
  },
  "sampledInputs": [
    {
      "iteration": 1,
      "horizonYears": 24.3,
      "capitalUsdBn": 93.89,
      "launchMassT": 219.01,
      "planningLaunchCostUsdPerKg": 1834.19
    },
    {
      "iteration": 2,
      "horizonYears": 16.44,
      "capitalUsdBn": 164.44,
      "launchMassT": 174.75,
      "planningLaunchCostUsdPerKg": 2405.22
    },
    {
      "iteration": 3,
      "horizonYears": 10.16,
      "capitalUsdBn": 345.6,
      "launchMassT": 222.21,
      "planningLaunchCostUsdPerKg": 1663.65
    },
    {
      "iteration": 4,
      "horizonYears": 16.37,
      "capitalUsdBn": 380.47,
      "launchMassT": 337.75,
      "planningLaunchCostUsdPerKg": 1170.13
    },
    {
      "iteration": 5,
      "horizonYears": 23.61,
      "capitalUsdBn": 388.06,
      "launchMassT": 203.2,
      "planningLaunchCostUsdPerKg": 1019.18
    },
    {
      "iteration": 6,
      "horizonYears": 24.76,
      "capitalUsdBn": 298.99,
      "launchMassT": 234.38,
      "planningLaunchCostUsdPerKg": 1101.43
    },
    {
      "iteration": 7,
      "horizonYears": 14.2,
      "capitalUsdBn": 302.09,
      "launchMassT": 330.53,
      "planningLaunchCostUsdPerKg": 2320.14
    },
    {
      "iteration": 8,
      "horizonYears": 24.46,
      "capitalUsdBn": 380.49,
      "launchMassT": 274.21,
      "planningLaunchCostUsdPerKg": 3129.8
    },
    {
      "iteration": 9,
      "horizonYears": 14.07,
      "capitalUsdBn": 147.82,
      "launchMassT": 203.35,
      "planningLaunchCostUsdPerKg": 1963.42
    },
    {
      "iteration": 10,
      "horizonYears": 24.84,
      "capitalUsdBn": 191.35,
      "launchMassT": 214.98,
      "planningLaunchCostUsdPerKg": 2391.45
    },
    {
      "iteration": 11,
      "horizonYears": 16.76,
      "capitalUsdBn": 401.5,
      "launchMassT": 233.39,
      "planningLaunchCostUsdPerKg": 1748.7
    },
    {
      "iteration": 12,
      "horizonYears": 12.3,
      "capitalUsdBn": 309,
      "launchMassT": 213.09,
      "planningLaunchCostUsdPerKg": 1892.41
    }
  ],
  "scenarioSummaries": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "deterministicUtility": 67.12,
      "paretoFrontierMember": true,
      "businessReadinessP10": 71.87,
      "businessReadinessMedian": 76.65,
      "businessReadinessP90": 81.23,
      "medianProgramNeedBn": 49.36,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 44.4,
      "underfundedProbabilityPercent": 0,
      "winProbabilityPercent": 75.78
    },
    {
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "deterministicUtility": 65.69,
      "paretoFrontierMember": false,
      "businessReadinessP10": 66.95,
      "businessReadinessMedian": 72.59,
      "businessReadinessP90": 78.5,
      "medianProgramNeedBn": 61.38,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 49.9,
      "underfundedProbabilityPercent": 0.39,
      "winProbabilityPercent": 24.22
    },
    {
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "deterministicUtility": 40.78,
      "paretoFrontierMember": false,
      "businessReadinessP10": 57.41,
      "businessReadinessMedian": 63.22,
      "businessReadinessP90": 68.72,
      "medianProgramNeedBn": 68.05,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 54.9,
      "underfundedProbabilityPercent": 1.95,
      "winProbabilityPercent": 0
    },
    {
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "deterministicUtility": 51.37,
      "paretoFrontierMember": false,
      "businessReadinessP10": 52.92,
      "businessReadinessMedian": 59.76,
      "businessReadinessP90": 67.27,
      "medianProgramNeedBn": 70,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 57.5,
      "underfundedProbabilityPercent": 2.73,
      "winProbabilityPercent": 0
    },
    {
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "deterministicUtility": 42.95,
      "paretoFrontierMember": false,
      "businessReadinessP10": 45.88,
      "businessReadinessMedian": 55.33,
      "businessReadinessP90": 64.63,
      "medianProgramNeedBn": 97.54,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 64.2,
      "underfundedProbabilityPercent": 10.94,
      "winProbabilityPercent": 0
    },
    {
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "deterministicUtility": 37.95,
      "paretoFrontierMember": false,
      "businessReadinessP10": 44.62,
      "businessReadinessMedian": 53.68,
      "businessReadinessP90": 63.86,
      "medianProgramNeedBn": 104.1,
      "medianCapitalGapBn": 0,
      "medianFundingCoveragePercent": 100,
      "medianBreakEvenPressure": 64.9,
      "underfundedProbabilityPercent": 11.91,
      "winProbabilityPercent": 0
    }
  ],
  "mostLikelyBusinessWinner": {
    "scenarioId": "moon-first",
    "name": "Moon-first Bootstrap",
    "deterministicUtility": 67.12,
    "paretoFrontierMember": true,
    "businessReadinessP10": 71.87,
    "businessReadinessMedian": 76.65,
    "businessReadinessP90": 81.23,
    "medianProgramNeedBn": 49.36,
    "medianCapitalGapBn": 0,
    "medianFundingCoveragePercent": 100,
    "medianBreakEvenPressure": 44.4,
    "underfundedProbabilityPercent": 0,
    "winProbabilityPercent": 75.78
  },
  "crossoverSignals": [
    {
      "scenarioId": "moon-first",
      "rankByMedianReadiness": 1,
      "canWinSampledEconomics": true,
      "underfundingIsDominant": false,
      "paretoFrontierMember": true
    },
    {
      "scenarioId": "hybrid",
      "rankByMedianReadiness": 2,
      "canWinSampledEconomics": true,
      "underfundingIsDominant": false,
      "paretoFrontierMember": false
    },
    {
      "scenarioId": "mars-first",
      "rankByMedianReadiness": 3,
      "canWinSampledEconomics": false,
      "underfundingIsDominant": false,
      "paretoFrontierMember": false
    },
    {
      "scenarioId": "asteroid-first",
      "rankByMedianReadiness": 4,
      "canWinSampledEconomics": false,
      "underfundingIsDominant": false,
      "paretoFrontierMember": false
    },
    {
      "scenarioId": "mercury-orbit",
      "rankByMedianReadiness": 5,
      "canWinSampledEconomics": false,
      "underfundingIsDominant": false,
      "paretoFrontierMember": false
    },
    {
      "scenarioId": "mercury-polar",
      "rankByMedianReadiness": 6,
      "canWinSampledEconomics": false,
      "underfundingIsDominant": false,
      "paretoFrontierMember": false
    }
  ],
  "evidenceHashes": {
    "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
    "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "assumptionRegistry": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02"
  },
  "linkedAssumptions": [
    {
      "id": "assumption-no-mercury-first",
      "title": "Mercury cannot be hardcoded as the winning scenario",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
    },
    {
      "id": "assumption-launch-cost-ranges",
      "title": "Launch economics must use dated ranges and sensitivity bands",
      "state": "hypothesis",
      "uncertainty": "High",
      "testGate": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
    }
  ],
  "promotionBlockers": [
    "Launch-cost ranges are internal planning bands until dated source records are attached.",
    "Capex, opex, and demand assumptions are not yet source-backed.",
    "No runtime trajectory/logistics sidecar has promoted mission feasibility claims."
  ],
  "reportHash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf"
}
;
